import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode } from "vue"

import { computed, nextTick, onMounted, ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'IfViewport',
  props: {
  minWidth: {
    type: [String, Number],
    default: 0,
  },

  maxWidth: {
    type: [String, Number],
    default: Infinity,
  },
},
  setup(__props) {

const props = __props

const viewportWidth = ref<number>(window.innerWidth)

const isVisible = computed<boolean>(
  (): boolean =>
    props.minWidth <= viewportWidth.value &&
    viewportWidth.value <= props.maxWidth,
)

const onWindowResize = (): void => {
  viewportWidth.value = window.innerWidth
}

onMounted(() => {
  nextTick(() => {
    window.addEventListener('resize', onWindowResize)
  })
})

return (_ctx: any,_cache: any) => {
  return (isVisible.value)
    ? _renderSlot(_ctx.$slots, "default", { key: 0 })
    : _createCommentVNode("", true)
}
}

})